// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_eM","advertDetailContactItem__link":"c-n_eN"};